export default function blurAll(): void {
    const focusNode = document.querySelector('*:focus') as HTMLElement;

    if (focusNode) {
        focusNode.blur();
    }
}
